module.exports = __webpack_public_path__ + "static/media/pawritten.3ceb6064.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten.svg
// module id = ./src/assets/fonts/pawritten.svg
// module chunks = 6